import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import HubspotForm from 'react-hubspot-form';
import { userDetail } from 'Stores/userDetail';
import freeTrialPopupState from 'Stores/freeTrialPopupState';
import * as CONSTANTS from 'Utils/constants';
import Banner1 from 'Assets/png/prospector_banners/banner1.png';
import Banner2 from 'Assets/png/prospector_banners/banner2.png';
import Banner3 from 'Assets/png/prospector_banners/banner3.png';
import freeTrialPopupBanner from 'Assets/png/free-trial-popup-banner.png';
import { ReactComponent as TickIcon } from 'Assets/svg/tick-icon-new.svg';
import { HocPopupComponent } from 'Components/common/hocPopupComponent';
import { Utils } from 'Utils/utils';
import { URLS, makeApi } from 'Utils/apiUtil';
import { toasterState } from 'Components/common/toaster';
import { LoadingWrapper } from './loadingWrapper';
import Button from './Button';
import Carousel from './carousel';

const bannerImages = [Banner1, Banner2, Banner3];

const {
  FREE_TRIAL_POPUP_TRIGGERS,
  MX_ONBOARDING_EVENTS,
  MX_PROFILE_PROPERTIES,
} = CONSTANTS;
const {
  VIEW_LIST,
  EXPORT_CONTACT,
  SINGLE_VIEW_CONTACTS,
  WEBSITE_VIEW_CONTACTS,
  DIRECT_ACCESS,
  HEADER_BUTTON_ACTION,
} = FREE_TRIAL_POPUP_TRIGGERS;
const tenSecondSleepOptions = [
  VIEW_LIST,
  SINGLE_VIEW_CONTACTS,
  WEBSITE_VIEW_CONTACTS,
  DIRECT_ACCESS,
];

const {
  LB_AP_START_FREE_TRIAL_ACTION_TRIGGER,
  LB_AP_POPUP_START_FREE_TRIAL_INFO_SCREEN,
  LB_AP_POPUP_START_FREE_TRIAL_EMAIL_SCREEN,
  LB_AP_POPUP_START_FREE_TRIAL_FORM_SCREEN,
  LB_AP_POPUP_START_FREE_TRIAL_SUBMITTED,
} = MX_ONBOARDING_EVENTS;

const { AP_TRIAL_REQUEST_USER_TYPE } = MX_PROFILE_PROPERTIES;

const ProspectorFreeTrialPrePopup = props => {
  const { freeTrialPrePopup, dynamicText, setShowPopup = () => {} } = props;
  const [trialApiLoading, setTrialApiLoading] = useState(false);

  const submitTrialRequest = () => {
    setTrialApiLoading(true);
    if (!trialApiLoading) {
      const failedCallback = () => {
        setTrialApiLoading(false);
        toasterState.setToastMsg(
          'Unable to process your request now, please try again later ',
          'failure',
        );
      };
      freeTrialPopupState.processTrialRequest(failedCallback);
    }
  };

  return (
    <>
      <Carousel
        list={bannerImages}
        renderItem={item => {
          return (
            // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
            <img src={item} alt="banner" />
          );
        }}
        itemWidth={710}
      />
      <div className="text-wrapper">
        <div>
          {freeTrialPrePopup === SINGLE_VIEW_CONTACTS ||
          freeTrialPrePopup === WEBSITE_VIEW_CONTACTS ? (
            <>
              <div className="title">You are almost there! </div>
              <div className="description">
                Looking for more information? Get access to all employee data at{' '}
                <span className="custom-link-style">{dynamicText}</span> when
                you signup for our FREE trial.
              </div>
            </>
          ) : freeTrialPrePopup === EXPORT_CONTACT ? (
            <>
              <div className="title">Close your customers at scale</div>
              <div className="description">
                Sign-up for Adapt free trial and get access to{' '}
                {CONSTANTS.CONTACT_COUNT_IN_MILLIONS} contacts instantly. With
                Adapt Web Platform and{' '}
                <span className="custom-link-style">{dynamicText}</span> you
                can,
                <div className="info-list">
                  <div className="info-item">
                    <TickIcon className="tick-icon" /> Power up your CRM with
                    Adapt’s data in a single click.
                  </div>
                  <div className="info-item">
                    <TickIcon className="tick-icon" /> Improve productivty by
                    automating your data export using workflows and Adapt.
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="title">
                Build your prospecting lists with precision search
              </div>
              <div className="description">
                Signup for our FREE trial and search your target contacts within
                the Adapt Web Platform.
              </div>
            </>
          )}
        </div>
        <Button
          btnText="Start Free Trial"
          icon={false}
          iconName=""
          type="button"
          className={`action-btn ${trialApiLoading ? ' loading' : ''}`}
          loader={trialApiLoading}
          click={e => submitTrialRequest(e)}
        />
      </div>
    </>
  );
};

const RightWrapper = props => {
  const { currentStep, email, handleEmailValidateClick = () => {} } = props;
  const [secondaryEmail, setSecondaryEmail] = useState('');
  const [isLoading, setIsLoading] = useState('');
  const [errorInfo, setErrorInfo] = useState(null);
  const [showFormSubmissionMessage, setShowFormSubmissionMessage] = useState(
    false,
  );
  const [trialApiLoading, setTrialApiLoading] = useState(false);

  const changeValue = event => {
    setSecondaryEmail(event.currentTarget.value);
  };

  const submitTrialRequest = async (postData = {}) => {
    try {
      setErrorInfo(null);
      if (!isLoading)
        if (secondaryEmail) {
          const config = {
            url: URLS.verifyLBTrialRequest,
            method: 'POST',
            data: postData,
          };
          setTrialApiLoading(true);

          const response = await makeApi(config);

          let msgStr = '';
          const { data = null } = response;
          if (data) {
            const { responseCode = null } = data;
            if (responseCode === 200) {
              Utils.mixpanelUpdateProfileProperty({
                [AP_TRIAL_REQUEST_USER_TYPE]: 'Non Business',
              });
              Utils.mixpanelTrack(LB_AP_POPUP_START_FREE_TRIAL_SUBMITTED, {});
              Utils.redirectToLbHomePage();
            } else if (responseCode === 201) {
              Utils.mixpanelUpdateProfileProperty({
                [AP_TRIAL_REQUEST_USER_TYPE]: 'Business',
              });
              Utils.mixpanelTrack(LB_AP_POPUP_START_FREE_TRIAL_SUBMITTED, {});
              Utils.setCookie('trial_activate_success', true);
              Utils.redirectToLbHomePage();
            } else if (responseCode === 202) {
              msgStr = 'email_exist';
            } else if (responseCode === 203) {
              msgStr = 'invalid_business_email';
            } else {
              msgStr = 'common_error';
            }
          }
          setTrialApiLoading(false);
        } else {
          setErrorInfo('validation_failed');
        }
    } catch (e) {
      setTrialApiLoading(false);
      console.log('checking Is Account Exist failed', e);
    }
  };

  const hubspotSuccessCallback = (formData = []) => {
    setTimeout(() => {
      const postData = {};
      // eslint-disable-next-line array-callback-return
      formData.map(item => {
        const { name = null, value } = item;
        if (name && name !== 'hs_context') postData[name] = value;
      });
      setShowFormSubmissionMessage(true);
      submitTrialRequest(postData);
    }, 300);
  };

  const HSFormWrapper = () => {
    const [showEmailBox, setShowEmailBox] = useState(false);
    return (
      <div className="hubspot-form">
        {!trialApiLoading ? (
          <>
            {showEmailBox && (
              <input
                type="email"
                className="input-box"
                placeholder="Work Email"
                autoComplete="off"
                readOnly
                value={secondaryEmail}
              />
            )}
            <HubspotForm
              portalId={CONSTANTS.HUBSPOT_PORTAL_ID}
              formId={CONSTANTS.PROSPECTOR_USER_TRIAL_FORM}
              inlineMessage="Thank you! Your trial request is successfully placed. This page will automatically redirect."
              onSubmit={formData => {
                setTimeout(() => {
                  hubspotSuccessCallback(formData);
                }, 250);
              }}
              onReady={form => {
                setShowEmailBox(true);
                setTimeout(() => {
                  Utils.removeQueryParamToUrl('email');
                }, 500);
              }}
              loading={
                <div className="loading-icon">
                  <LoadingWrapper show />
                </div>
              }
            />
          </>
        ) : (
          <div className="loading-icon">
            <LoadingWrapper show />
          </div>
        )}
      </div>
    );
  };

  const checkIsAccountExist = async () => {
    try {
      setErrorInfo(null);
      if (!isLoading)
        if (secondaryEmail) {
          const config = {
            url: `${URLS.getMemberInfoUsingEmail}?email=${secondaryEmail}`,
          };

          setIsLoading(true);
          const response = await makeApi(config);
          if (response?.data) {
            const { member = null, error = null } = response.data;
            if (error !== null) {
              if (error === 'invalid_email_format')
                setErrorInfo('validation_failed');
            } else if (member === null) {
              Utils.addQueryParamToUrl('email', secondaryEmail);
              handleEmailValidateClick(secondaryEmail);
            } else if (member !== null) {
              setErrorInfo('email_exist');
            }
          } else {
            setErrorInfo('common');
          }

          setIsLoading(false);
        } else {
          setErrorInfo('validation_failed');
        }
    } catch (e) {
      setIsLoading(false);
      setErrorInfo('common');
      console.log('checking Is Account Exist failed', e);
    }
  };

  useEffect(() => {
    if (Utils.isBusinessEmail()) {
      const bEmail = Utils.isBusinessEmail();
      setSecondaryEmail(bEmail);
      Utils.addQueryParamToUrl('email', bEmail);
      handleEmailValidateClick(bEmail);
    }
  }, []);

  return (
    <div className="right-wrapper">
      <div className="step-wrapper">
        <div
          className={`step-item ${
            currentStep === 1 ? ' active' : ' completed'
          }`}
        >
          {currentStep === 1 ? '1' : <TickIcon className="tick-icon" />}
        </div>
        <div className="connector-border" />
        <div className={`step-item ${currentStep === 2 ? ' active' : ''}`}>
          2
        </div>
      </div>
      <div className="title-wrapper">
        Signup for a 7 Day Free Trial With <b>Adapt WebPlatform</b>
      </div>
      {currentStep === 1 ? (
        <div className="content-info-wrapper">
          <div className="info-item-list">
            <div className="info-item">
              <TickIcon className="tick-icon" /> No credit card required{' '}
            </div>
            <div className="info-item">
              <TickIcon className="tick-icon" /> All features unlocked{' '}
            </div>
            <div className="info-item">
              <TickIcon className="tick-icon" /> Direct access to{' '}
              {CONSTANTS.CONTACT_COUNT_IN_MILLIONS} contacts
            </div>
          </div>
          <div className="email-input-wrapper">
            <input
              type="email"
              className="input-box"
              placeholder="Work Email"
              autoComplete="off"
              onChange={e => changeValue(e)}
              value={secondaryEmail}
            />
            <span
              className={`error-wrapper ${
                errorInfo !== null ? '' : 'hide-visibility'
              }`}
            >
              {errorInfo === 'email_exist' ? (
                <>
                  The email address you have entered is already registered.
                  Please{' '}
                  <a
                    href="mailto:support@adapt.io"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    contact us
                  </a>{' '}
                  for more details.
                </>
              ) : errorInfo === 'validation_failed' ? (
                <>Please enter a valid email address</>
              ) : (
                <>
                  Oops! Something went wrong! Please try again in some time or{' '}
                  <a
                    href="mailto:support@adapt.io"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    contact us
                  </a>
                  .
                </>
              )}
            </span>
          </div>
          <Button
            btnText="Start Free Trial"
            icon={false}
            iconName=""
            type="button"
            className={`action-btn ${isLoading ? ' loading' : ''}`}
            loader={isLoading}
            click={e => checkIsAccountExist(e)}
          />
        </div>
      ) : (
        <div className="content-info-wrapper">
          <HSFormWrapper />
        </div>
      )}
    </div>
  );
};

const FreeTrialFormPopup = observer(props => {
  const { freeTrialPrePopup, dynamicText } = props;
  const [currentStep, setCurrentStep] = useState(1);
  const [errorInfo, setErrorInfo] = useState(null);
  const { userInfo } = userDetail;
  const { email } = userInfo;

  const LeftWrapper = () => {
    return (
      <div className="left-wrapper">
        <div className="img-wrapper">
          <img
            src={freeTrialPopupBanner}
            className="top-banner"
            alt="freeTrialPopupBanner"
          />
        </div>
        <div className="primary-email-wrapper">
          <div className="title-wrapper">Primary email*</div>
          <div className="email-wrapper">{email}</div>
        </div>
        <div className="note-wrapper">
          <b>Note:</b> To access the chrome plugin and Adapt Web Platform please
          use the previously registered email id as mentioned above. All your
          email communications for the product, support, or sales will be sent
          to the primary account id.
        </div>
      </div>
    );
  };

  const handleEmailValidateClick = secondaryEmail => {
    if (secondaryEmail) setCurrentStep(2);
  };

  useEffect(() => {
    if (currentStep === 1)
      Utils.mixpanelTrack(LB_AP_POPUP_START_FREE_TRIAL_EMAIL_SCREEN, {});
    else if (currentStep === 2)
      Utils.mixpanelTrack(LB_AP_POPUP_START_FREE_TRIAL_FORM_SCREEN, {});
  }, [currentStep]);

  return (
    <>
      <LeftWrapper />
      <RightWrapper
        currentStep={currentStep}
        errorInfo={errorInfo}
        handleEmailValidateClick={handleEmailValidateClick}
        email={email}
      />
    </>
  );
});

let showAfterTimeout = false;

const ProspectorFreeTrialPopup = observer(() => {
  const { freeTrialPrePopup, dynamicText } = freeTrialPopupState;
  const [showPopup, setShowPopup] = useState(0);
  const [showFormOnly, setShowFormOnly] = useState(false);
  /* showPopup values and use case
    0 - false 
    1 - pre popup
    2 - free trial form popup
  */

  const updatePopupValue = value => {
    if (value > 0)
      Utils.mixpanelTrack(LB_AP_POPUP_START_FREE_TRIAL_INFO_SCREEN, {});
    setShowPopup(value);
  };

  const trackMxTriggerEvent = eventName => {
    Utils.mixpanelTrack(LB_AP_START_FREE_TRIAL_ACTION_TRIGGER, {
      triggerPlace: eventName,
    });
  };

  useEffect(() => {
    if (
      !Utils.isPaidSubscription() &&
      !Utils.isFreeTrialPlan() &&
      !Utils.isTrialUsed() &&
      freeTrialPrePopup !== null
    )
      if (freeTrialPrePopup === EXPORT_CONTACT) {
        updatePopupValue(1);
        trackMxTriggerEvent(freeTrialPrePopup);
      } else if (tenSecondSleepOptions.includes(freeTrialPrePopup)) {
        showAfterTimeout = true;
        trackMxTriggerEvent(freeTrialPrePopup);
        // eslint-disable-next-line no-inner-declarations
        function updateAfterTimeout() {
          if (showAfterTimeout) updatePopupValue(1);
        }
        setTimeout(updateAfterTimeout, 10000);
      } else if (freeTrialPrePopup === HEADER_BUTTON_ACTION) {
        showAfterTimeout = false;
        trackMxTriggerEvent(freeTrialPrePopup);
        updatePopupValue(2);
      } else {
        trackMxTriggerEvent('unknown');
        updatePopupValue(1);
      }
    else updatePopupValue(0);
  }, [freeTrialPrePopup]);

  useEffect(() => {
    if (Utils.isBusinessEmail() && showPopup === 2) setShowFormOnly(true);
  }, [showPopup]);

  const closeClick = () => {
    freeTrialPopupState.setFreeTrialPrePopup(null);
  };

  return showPopup > 0 ? (
    <HocPopupComponent
      customClassName={
        showPopup === 1
          ? 'prospector-free-trial-popup'
          : 'free-trial-form-popup'
      }
      customClassNameOnly={showFormOnly ? ' free-trial-form-popup-only' : ''}
      allowMaskClick
      closeClick={closeClick}
    >
      {showPopup === 1 ? (
        <ProspectorFreeTrialPrePopup
          freeTrialPrePopup={freeTrialPrePopup}
          dynamicText={dynamicText}
          setShowPopup={setShowPopup}
        />
      ) : (
        ''
      )}
    </HocPopupComponent>
  ) : (
    ''
  );
});

export default ProspectorFreeTrialPopup;
